import type { FlightLegCopy } from '@voll-intelligence/intelligence-ui-kit';
import { genUiI18n, type GenUiTranslate } from './i18n.js';

/** A condição do trecho (Direto / N paradas) no catálogo: singular só quando
 *  `count === 1`. */
export function legStopsCopy(t: GenUiTranslate): Pick<FlightLegCopy, 'direct' | 'stops'> {
  return {
    direct: t('common.direct'),
    stops: (count) =>
      t(count === 1 ? 'voucher.detail.stop_one' : 'voucher.detail.stop_other', { count }),
  };
}

/** Os textos da perna do kit no locale do host. Função pura, como o
 *  `flightFilterCopy`: o host memoiza por locale. */
export function flightLegCopy(locale: string | null | undefined): FlightLegCopy {
  const { t } = genUiI18n(locale);
  return {
    ...legStopsCopy(t),
    viewDetail: t('flight.segment.viewDetail'),
    arrivesNextDay: (days) =>
      t(days === 1 ? 'flight.segment.arrivesNextDay_one' : 'flight.segment.arrivesNextDay_other', {
        count: days,
      }),
    kind: {
      outbound: t('flightOffers.legOutbound'),
      return: t('flightOffers.legReturn'),
      leg: t('flightOffers.legOutbound'),
    },
  };
}
